// Brand
export const BRAND_NAME = "suewag-ebm";
// UIKit version
export const UIKIT_VERSION = "4.8.0";

// businesscardAuthor
export const BUSINESSCARD_AUTHOR_ALIGNMENT_LEFT = "left";
export const BUSINESSCARD_AUTHOR_ALIGNMENT_CENTER = "center";
export const BUSINESSCARD_AUTHOR_ALIGNMENT_RIGHT = "right";
export const BUSINESSCARD_AUTHOR_ALIGNMENT = [
  BUSINESSCARD_AUTHOR_ALIGNMENT_LEFT,
  BUSINESSCARD_AUTHOR_ALIGNMENT_CENTER,
  BUSINESSCARD_AUTHOR_ALIGNMENT_RIGHT
] as const;
export type BusinesscardAuthorAlignment = typeof BUSINESSCARD_AUTHOR_ALIGNMENT[number];
//defaultAlignment
export const BUSINESSCARD_AUTHOR_DEFAULT_ALIGNMENT = "left";

// businesscardContact
export const BUSINESSCARD_CONTACT_ALIGNMENT_LEFT = "left";
export const BUSINESSCARD_CONTACT_ALIGNMENT_CENTER = "center";
export const BUSINESSCARD_CONTACT_ALIGNMENT_RIGHT = "right";
export const BUSINESSCARD_CONTACT_ALIGNMENT = [
  BUSINESSCARD_CONTACT_ALIGNMENT_LEFT,
  BUSINESSCARD_CONTACT_ALIGNMENT_CENTER,
  BUSINESSCARD_CONTACT_ALIGNMENT_RIGHT
] as const;
export type BusinesscardContactAlignment = typeof BUSINESSCARD_CONTACT_ALIGNMENT[number];
//defaultAlignment
export const BUSINESSCARD_CONTACT_DEFAULT_ALIGNMENT = "left";

// pictogram
export const PICTOGRAM_ALIGNMENT_LEFT = "left";
export const PICTOGRAM_ALIGNMENT_CENTER = "center";
export const PICTOGRAM_ALIGNMENT_RIGHT = "right";
export const PICTOGRAM_ALIGNMENT = [
  PICTOGRAM_ALIGNMENT_LEFT,
  PICTOGRAM_ALIGNMENT_CENTER,
  PICTOGRAM_ALIGNMENT_RIGHT
] as const;
export type PictogramAlignment = typeof PICTOGRAM_ALIGNMENT[number];
//defaultAlignment
export const PICTOGRAM_DEFAULT_ALIGNMENT = "left";

// stage
export const STAGE_ALIGNMENT_LEFT = "left";
export const STAGE_ALIGNMENT_CENTER = "center";
export const STAGE_ALIGNMENT_RIGHT = "right";
export const STAGE_ALIGNMENT = [STAGE_ALIGNMENT_LEFT, STAGE_ALIGNMENT_CENTER, STAGE_ALIGNMENT_RIGHT] as const;
export type StageAlignment = typeof STAGE_ALIGNMENT[number];
//defaultAlignment

//Squircle configuration
export const IS_SQUIRCLE = true;

// basicTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const BASIC_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type BasicTeaserViolatorHorizontalPosition = typeof BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// basicTeaser: TYPE || CONTENT_ALIGNMENT
export const BASIC_TEASER_DEFAULT_CONTENT_ALIGNMENT = "left";
export const BASIC_TEASER_CONTENT_ALIGNMENT_LEFT = "left";
export const BASIC_TEASER_CONTENT_ALIGNMENT_CENTER = "center";
export const BASIC_TEASER_CONTENT_ALIGNMENT_PRODUCT = "product";

export const BASIC_TEASER_CONTENT_ALIGNMENTS = [
  BASIC_TEASER_CONTENT_ALIGNMENT_LEFT,
  BASIC_TEASER_CONTENT_ALIGNMENT_CENTER,
  BASIC_TEASER_CONTENT_ALIGNMENT_PRODUCT
] as const;

export type BasicTeaserContentAlignment = typeof BASIC_TEASER_CONTENT_ALIGNMENTS[number];

// box: TYPE || CONTENT_HORIZONTAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_HORIZONTAL_ALIGNMENT = "left";
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT = "left";
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER = "center";

export const BOX_CONTENT_HORIZONTAL_ALIGNMENTS = [
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT,
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER
] as const;

export type BoxContentHorizontalAlignment = typeof BOX_CONTENT_HORIZONTAL_ALIGNMENTS[number];

// box: TYPE || CONTENT_VERTICAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_VERTICAL_ALIGNMENT = "top";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_TOP = "top";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER = "center";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM = "bottom";

export const BOX_CONTENT_VERTICAL_ALIGNMENTS = [
  BOX_CONTENT_VERTICAL_ALIGNMENT_TOP,
  BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER,
  BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM
] as const;

export type BoxContentVerticalAlignment = typeof BOX_CONTENT_VERTICAL_ALIGNMENTS[number];

// button: TYPE || ICON_POSITION
export const BUTTON_DEFAULT_ICON_POSITION = "left";
export const BUTTON_ICON_POSITION_LEFT = "left";
export const BUTTON_ICON_POSITION_RIGHT = "right";

export const BUTTON_ICON_POSITIONS = [BUTTON_ICON_POSITION_LEFT, BUTTON_ICON_POSITION_RIGHT] as const;

export type ButtonIconPosition = typeof BUTTON_ICON_POSITIONS[number];

// cardTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const CARD_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type CardTeaserViolatorHorizontalPosition = typeof CARD_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// cardTeaser: TYPE || VIOLATOR_VERTICAL_POSITION
export const CARD_TEASER_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const CARD_TEASER_VIOLATOR_VERTICAL_POSITIONS = [
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_TOP,
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_CENTER,
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type CardTeaserViolatorVerticalPosition = typeof CARD_TEASER_VIOLATOR_VERTICAL_POSITIONS[number];

// cardTeaser: TYPE || PROMO_FLAG_ALIGNMENT
export const CARD_TEASER_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const CARD_TEASER_PROMO_FLAG_ALIGNMENTS = [
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_LEFT,
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_CENTER,
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type CardTeaserPromoFlagAlignment = typeof CARD_TEASER_PROMO_FLAG_ALIGNMENTS[number];

// cardTeaserOffset: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const CARD_TEASER_OFFSET_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITIONS = [
  CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type CardTeaserOffsetViolatorHorizontalPosition = typeof CARD_TEASER_OFFSET_VIOLATOR_HORIZONTAL_POSITIONS[number];

// cardTeaserOffset: TYPE || VIOLATOR_VERTICAL_POSITION
export const CARD_TEASER_OFFSET_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITIONS = [
  CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITION_TOP,
  CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITION_CENTER,
  CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type CardTeaserOffsetViolatorVerticalPosition = typeof CARD_TEASER_OFFSET_VIOLATOR_VERTICAL_POSITIONS[number];

// cardTeaserOffset: TYPE || PROMO_FLAG_ALIGNMENT
export const CARD_TEASER_OFFSET_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENTS = [
  CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENT_LEFT,
  CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENT_CENTER,
  CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type CardTeaserOffsetPromoFlagAlignment = typeof CARD_TEASER_OFFSET_PROMO_FLAG_ALIGNMENTS[number];

// checkbox: TYPE || GROUP_LABEL_FORMAT
export const CHECKBOX_DEFAULT_GROUP_LABEL_FORMAT = "copy";
export const CHECKBOX_GROUP_LABEL_FORMAT_H3 = "h3";
export const CHECKBOX_GROUP_LABEL_FORMAT_H4 = "h4";
export const CHECKBOX_GROUP_LABEL_FORMAT_H5 = "h5";
export const CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT = "abstract";
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY = "copy";
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL = "copy-small";

export const CHECKBOX_GROUP_LABEL_FORMATS = [
  CHECKBOX_GROUP_LABEL_FORMAT_H3,
  CHECKBOX_GROUP_LABEL_FORMAT_H4,
  CHECKBOX_GROUP_LABEL_FORMAT_H5,
  CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL
] as const;

export type CheckboxGroupLabelFormat = typeof CHECKBOX_GROUP_LABEL_FORMATS[number];

// headline: TYPE || ALIGNMENT
export const HEADLINE_DEFAULT_ALIGNMENT = "left";
export const HEADLINE_ALIGNMENT_LEFT = "left";
export const HEADLINE_ALIGNMENT_CENTER = "center";
export const HEADLINE_ALIGNMENT_RIGHT = "right";

export const HEADLINE_ALIGNMENTS = [
  HEADLINE_ALIGNMENT_LEFT,
  HEADLINE_ALIGNMENT_CENTER,
  HEADLINE_ALIGNMENT_RIGHT
] as const;

export type HeadlineAlignment = typeof HEADLINE_ALIGNMENTS[number];

// image: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const IMAGE_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const IMAGE_VIOLATOR_HORIZONTAL_POSITIONS = [
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type ImageViolatorHorizontalPosition = typeof IMAGE_VIOLATOR_HORIZONTAL_POSITIONS[number];

// image: TYPE || VIOLATOR_VERTICAL_POSITION
export const IMAGE_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const IMAGE_VIOLATOR_VERTICAL_POSITIONS = [
  IMAGE_VIOLATOR_VERTICAL_POSITION_TOP,
  IMAGE_VIOLATOR_VERTICAL_POSITION_CENTER,
  IMAGE_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type ImageViolatorVerticalPosition = typeof IMAGE_VIOLATOR_VERTICAL_POSITIONS[number];

// link: TYPE || ICON_POSITION
export const LINK_DEFAULT_ICON_POSITION = "right";
export const LINK_ICON_POSITION_LEFT = "left";
export const LINK_ICON_POSITION_RIGHT = "right";

export const LINK_ICON_POSITIONS = [LINK_ICON_POSITION_LEFT, LINK_ICON_POSITION_RIGHT] as const;

export type LinkIconPosition = typeof LINK_ICON_POSITIONS[number];

// multiContentStage: TYPE || PROMO_FLAG_ALIGNMENT
export const MULTI_CONTENT_STAGE_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENTS = [
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_LEFT,
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_CENTER,
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type MultiContentStagePromoFlagAlignment = typeof MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENTS[number];

// multiContentStage: TYPE || COLOR_BACKGROUNDS
export const MULTI_CONTENT_STAGE_COLOR_BACKGROUNDS_KARIBIKBLAU = "karibikblau";

export const MULTI_CONTENT_STAGE_COLOR_BACKGROUNDSS = [MULTI_CONTENT_STAGE_COLOR_BACKGROUNDS_KARIBIKBLAU] as const;

export type MultiContentStageColorBackgrounds = typeof MULTI_CONTENT_STAGE_COLOR_BACKGROUNDSS[number];

// pageHeader: TYPE || HEADLINE_SIZE
export const PAGE_HEADER_DEFAULT_HEADLINE_SIZE = "h4";
export const PAGE_HEADER_HEADLINE_SIZE_H1 = "h1";
export const PAGE_HEADER_HEADLINE_SIZE_H2 = "h2";
export const PAGE_HEADER_HEADLINE_SIZE_H3 = "h3";
export const PAGE_HEADER_HEADLINE_SIZE_H4 = "h4";
export const PAGE_HEADER_HEADLINE_SIZE_H5 = "h5";

export const PAGE_HEADER_HEADLINE_SIZES = [
  PAGE_HEADER_HEADLINE_SIZE_H1,
  PAGE_HEADER_HEADLINE_SIZE_H2,
  PAGE_HEADER_HEADLINE_SIZE_H3,
  PAGE_HEADER_HEADLINE_SIZE_H4,
  PAGE_HEADER_HEADLINE_SIZE_H5
] as const;

export type PageHeaderHeadlineSize = typeof PAGE_HEADER_HEADLINE_SIZES[number];

// pageHeader: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const PAGE_HEADER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type PageHeaderViolatorHorizontalPosition = typeof PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// pageHeader: TYPE || VIOLATOR_VERTICAL_POSITION
export const PAGE_HEADER_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_TOP,
  PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type PageHeaderViolatorVerticalPosition = typeof PAGE_HEADER_VIOLATOR_VERTICAL_POSITIONS[number];

// pageHeader: TYPE || LAYOUT
export const PAGE_HEADER_DEFAULT_LAYOUT = "horizontal";
export const PAGE_HEADER_LAYOUT_HORIZONTAL = "horizontal";
export const PAGE_HEADER_LAYOUT_VERTICAL = "vertical";

export const PAGE_HEADER_LAYOUTS = [PAGE_HEADER_LAYOUT_HORIZONTAL, PAGE_HEADER_LAYOUT_VERTICAL] as const;

export type PageHeaderLayout = typeof PAGE_HEADER_LAYOUTS[number];

// pageHeader: TYPE || VARIANT
export const PAGE_HEADER_DEFAULT_VARIANT = "default";
export const PAGE_HEADER_VARIANT_DEFAULT = "default";
export const PAGE_HEADER_VARIANT_ONLY_IMAGE = "only_image";

export const PAGE_HEADER_VARIANTS = [PAGE_HEADER_VARIANT_DEFAULT, PAGE_HEADER_VARIANT_ONLY_IMAGE] as const;

export type PageHeaderVariant = typeof PAGE_HEADER_VARIANTS[number];

// pageHeader: TYPE || HORIZONTAL_CONTENT_ALIGNMENT
export const PAGE_HEADER_DEFAULT_HORIZONTAL_CONTENT_ALIGNMENT = "left";
export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT = "left";
export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER = "center";
export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_RIGHT = "right";

export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENTS = [
  PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT,
  PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER,
  PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_RIGHT
] as const;

export type PageHeaderHorizontalContentAlignment = typeof PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENTS[number];

// pageHeader: TYPE || VERTICAL_CONTENT_ALIGNMENT
export const PAGE_HEADER_DEFAULT_VERTICAL_CONTENT_ALIGNMENT = "distant";
export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_DISTANT = "distant";
export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_CENTER = "center";
export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_TOP = "top";
export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_BOTTOM = "bottom";

export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENTS = [
  PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_DISTANT,
  PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_CENTER,
  PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_TOP,
  PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_BOTTOM
] as const;

export type PageHeaderVerticalContentAlignment = typeof PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENTS[number];

// pageHeaderCircle: TYPE || HEADLINE_SIZE
export const PAGE_HEADER_CIRCLE_DEFAULT_HEADLINE_SIZE = "h1";
export const PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H1 = "h1";
export const PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H2 = "h2";
export const PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H3 = "h3";
export const PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H4 = "h4";
export const PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H5 = "h5";

export const PAGE_HEADER_CIRCLE_HEADLINE_SIZES = [
  PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H1,
  PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H2,
  PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H3,
  PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H4,
  PAGE_HEADER_CIRCLE_HEADLINE_SIZE_H5
] as const;

export type PageHeaderCircleHeadlineSize = typeof PAGE_HEADER_CIRCLE_HEADLINE_SIZES[number];

// slider: TYPE || LABEL_FORMAT
export const SLIDER_DEFAULT_LABEL_FORMAT = "copy";
export const SLIDER_LABEL_FORMAT_H3 = "h3";
export const SLIDER_LABEL_FORMAT_H4 = "h4";
export const SLIDER_LABEL_FORMAT_H5 = "h5";
export const SLIDER_LABEL_FORMAT_ABSTRACT = "abstract";
export const SLIDER_LABEL_FORMAT_COPY = "copy";
export const SLIDER_LABEL_FORMAT_COPY_SMALL = "copy-small";

export const SLIDER_LABEL_FORMATS = [
  SLIDER_LABEL_FORMAT_H3,
  SLIDER_LABEL_FORMAT_H4,
  SLIDER_LABEL_FORMAT_H5,
  SLIDER_LABEL_FORMAT_ABSTRACT,
  SLIDER_LABEL_FORMAT_COPY,
  SLIDER_LABEL_FORMAT_COPY_SMALL
] as const;

export type SliderLabelFormat = typeof SLIDER_LABEL_FORMATS[number];

// stage: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const STAGE_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const STAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const STAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const STAGE_VIOLATOR_HORIZONTAL_POSITIONS = [
  STAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  STAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type StageViolatorHorizontalPosition = typeof STAGE_VIOLATOR_HORIZONTAL_POSITIONS[number];

// textTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const TEXT_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type TextTeaserViolatorHorizontalPosition = typeof TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// textTeaser: TYPE || PROMO_FLAG_ALIGNMENT
export const TEXT_TEASER_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const TEXT_TEASER_PROMO_FLAG_ALIGNMENTS = [
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_LEFT,
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_CENTER,
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type TextTeaserPromoFlagAlignment = typeof TEXT_TEASER_PROMO_FLAG_ALIGNMENTS[number];

// tilesTeaser: TYPE || CONTENT_ALIGNMENT
export const TILES_TEASER_DEFAULT_CONTENT_ALIGNMENT = "left";
export const TILES_TEASER_CONTENT_ALIGNMENT_LEFT = "left";
export const TILES_TEASER_CONTENT_ALIGNMENT_CENTER = "center";
export const TILES_TEASER_CONTENT_ALIGNMENT_DISTANT = "distant";

export const TILES_TEASER_CONTENT_ALIGNMENTS = [
  TILES_TEASER_CONTENT_ALIGNMENT_LEFT,
  TILES_TEASER_CONTENT_ALIGNMENT_CENTER,
  TILES_TEASER_CONTENT_ALIGNMENT_DISTANT
] as const;

export type TilesTeaserContentAlignment = typeof TILES_TEASER_CONTENT_ALIGNMENTS[number];

// tilesTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const TILES_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "center";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type TilesTeaserViolatorHorizontalPosition = typeof TILES_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// tilesTeaser: TYPE || HORIZONTAL_CONTENT_ALIGNMENT
export const TILES_TEASER_DEFAULT_HORIZONTAL_CONTENT_ALIGNMENT = "center";
export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT = "left";
export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER = "center";
export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_RIGHT = "right";

export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENTS = [
  TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT,
  TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER,
  TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_RIGHT
] as const;

export type TilesTeaserHorizontalContentAlignment = typeof TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENTS[number];

// tilesTeaser: TYPE || VERTICAL_CONTENT_ALIGNMENT
export const TILES_TEASER_DEFAULT_VERTICAL_CONTENT_ALIGNMENT = "distant";
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_TOP = "top";
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_CENTER = "center";
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_BOTTOM = "bottom";
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_DISTANT = "distant";

export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENTS = [
  TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_TOP,
  TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_CENTER,
  TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_BOTTOM,
  TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_DISTANT
] as const;

export type TilesTeaserVerticalContentAlignment = typeof TILES_TEASER_VERTICAL_CONTENT_ALIGNMENTS[number];

// violator: TYPE || ALIGNMENT
export const VIOLATOR_DEFAULT_ALIGNMENT = "center";
export const VIOLATOR_ALIGNMENT_CENTER = "center";

export const VIOLATOR_ALIGNMENTS = [VIOLATOR_ALIGNMENT_CENTER] as const;

export type ViolatorAlignment = typeof VIOLATOR_ALIGNMENTS[number];

// violator: TYPE || POSITION
export const VIOLATOR_DEFAULT_POSITION = "center";
export const VIOLATOR_POSITION_TOP = "top";
export const VIOLATOR_POSITION_CENTER = "center";
export const VIOLATOR_POSITION_BOTTOM = "bottom";

export const VIOLATOR_POSITIONS = [VIOLATOR_POSITION_TOP, VIOLATOR_POSITION_CENTER, VIOLATOR_POSITION_BOTTOM] as const;

export type ViolatorPosition = typeof VIOLATOR_POSITIONS[number];

// violator: TYPE || PICTOGRAM_POSITION
export const VIOLATOR_DEFAULT_PICTOGRAM_POSITION = "center";
export const VIOLATOR_PICTOGRAM_POSITION_CENTER = "center";

export const VIOLATOR_PICTOGRAM_POSITIONS = [VIOLATOR_PICTOGRAM_POSITION_CENTER] as const;

export type ViolatorPictogramPosition = typeof VIOLATOR_PICTOGRAM_POSITIONS[number];

//Icon
export const ICON_CDN_URL = "https://revumbuiicons.blob.core.windows.net/$web/q";
export const ICON_VERSION = "1.11.0-suewag";

/* Component wise configuration */
// accordion
export const ACCORDION_SHOW_BAR = true as const;
// basicTeaser
export const BASIC_TEASER_HEADLINE_SIZES = ["h3", "h4", "h5"] as const;
export const BASIC_TEASER_HEADLINE_SIZE = "h5" as const;
export const BASIC_TEASER_COLORS = ["neutral100", "neutral800"] as const;
// businesscardContact
export const BUSINESSCARD_CONTACT_HEADLINE_SIZE = "h2" as const;
export const BUSINESSCARD_CONTACT_HEADLINE_SEO_TAG = "h2" as const;
// cardTeaser
export const CARD_TEASER_TEXT_POSITION = ["left", "center"] as const;
// cardTeaserOffset
export const CARD_TEASER_OFFSET_TEXT_POSITION = ["left", "center"] as const;
// cardTeaserOffset
export const CARD_TEASER_OFFSET_BACKGROUND_COLORS = [
  "Schwarz",
  "Orientgelb",
  "Fasergruen",
  "Arktisgruen",
  "Karibikblau",
  "Bischofsrot",
  "Kerzengelb",
  "Brillantkarmin",
  "Dahliengelb",
  "Leuchtendgruen",
  "Indiablau",
  "Alpenblau",
  "Hellgrau",
  "Mausgrau"
] as const;
// contentAggregator
export const CONTENT_AGGREGATOR_BACKGROUND_FOR_COLORFUL_VARIANT = "eon-bright" as const;
export const CONTENT_AGGREGATOR_COLORFUL_VARIANT_COLORS = ["eon-brillantkarmin", "eon-bright"] as const;
export const CONTENT_AGGREGATOR_TILE_BRIGHT_COLOR_SCHEME = "bright" as const;
export const CONTENT_AGGREGATOR_TILE_DEFAULT_COLOR_SCHEME = "Quartzgrau10" as const;
// contentAggregatorItem
export const CONTENT_AGGREGATOR_ITEM_ALTERNATIVE_TAG_PILL_SCHEME = "bischofsrot" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_TILE_LARGE = "h2" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_TILE_SMALL = "h3" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_LIST_LARGE = "h5" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_LIST_SMALL = "copy" as const;
// contextMenuItem
export const CONTEXT_MENU_ITEM_ACTIVE_ICON_SIZE = "tiny" as const;
// dataTable
export const DATA_TABLE_TOOLBAR_SELECTED_INNER_BACKGROUND = "eon-mellow-yellow-bright" as const;
export const DATA_TABLE_SEARCH_ICON_NAME = "magnifier" as const;
export const DATA_TABLE_SORT_ICON_NAME = "chevron_small_up" as const;
export const DATA_TABLE_EXPANDABLE_ICON_NAME = "arrow_down" as const;
// dropdown
export const DROPDOWN_CHEVRON_ICON_NAME = "chevron_bold_down" as const;
// dropdown
export const DROPDOWN_CHEVRON_SMALL_ICON_NAME = "chevron_small_down" as const;
// fileUpload
export const FILE_UPLOAD_SUMMERY_BACKGROUND_SCHEME = "eon-bright" as const;
// fileUpload
export const FILE_UPLOAD_SUCCESS_PROGRESS_ICON_COLOR = "eon-brillantkarmin" as const;
// fileUpload
export const FILE_UPLOAD_SUCCESS_PROGRESS_TEXT_COLOR = "eon-brillantkarmin" as const;
// fileUpload
export const FILE_UPLOAD_ERROR_PROGRESS_ICON_COLOR = "eon-bright" as const;
// fileUpload
export const FILE_UPLOAD_ERROR_PROGRESS_TEXT_COLOR = "eon-bright" as const;
// fileUpload
export const FILE_UPLOAD_ERROR_PROGRESS_SCHEME = "Schwarz" as const;
// footerBar
export const FOOTER_BAR_SHOW_COLOR_SEPARATOR = true as const;
// headline
export const HEADLINE_SCHEMES_ON_BACKGROUND_IMAGE = ["bright"] as const;
// icon
export const ICON_ICON_SCHEME = "Schwarz" as const;
// image
export const IMAGE_COMPONENTS_ON_DARK_IMAGE_BACKGROUND_SCHEME = "eon-bright" as const;
export const IMAGE_COMPONENTS_ON_BRIGHT_IMAGE_BACKGROUND_SCHEME = "eon-bright" as const;
// infoIcon
export const INFO_ICON_ICON_NAME = "info_large" as const;
// modal
export const MODAL_FOOTER_COLORS = ["eon-bright", "eon-alpenblau", "eon-brillantkarmin"] as const;
export const MODAL_FOOTER_DEFAULT_COLOR = "eon-bright" as const;
export const MODAL_ICON_SCHEME = "Schwarz" as const;
export const MODAL_HEADLINE_COLORS = ["Schwarz", "bright"] as const;
export const MODAL_DEFAULT_HEADLINE_COLOR = "Schwarz" as const;
// navigation
export const NAVIGATION_TOOLBAR_FLYOUT_INNER_BACKGROUND = "eon-atmospheric-anthracite" as const;
export const NAVIGATION_MAIN_FLYOUT_INNER_BACKGROUND = "bright" as const;
export const NAVIGATION_MOBILE_FLYOUT_INNER_BACKGROUND = "bright" as const;
export const NAVIGATION_SHOW_COLOR_SEPARATOR = false as const;
// offsetTeaser
export const OFFSET_TEASER_HEADLINE_SIZE = "h2" as const;
export const OFFSET_TEASER_SUBHEADLINE_SIZE = "h3" as const;
export const OFFSET_TEASER_CONTENT_ALIGNMENT = "left" as const;
export const OFFSET_TEASER_ALIGNMENT_HEADLINE = "right" as const;
export const OFFSET_TEASER_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_TWO_ALIGNMENT_HEADLINE = "left" as const;
export const OFFSET_TEASER_TWO_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_THREE_ALIGNMENT_HEADLINE = "left" as const;
export const OFFSET_TEASER_THREE_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_FOUR_ALIGNMENT_HEADLINE = "left" as const;
export const OFFSET_TEASER_FOUR_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
export const OFFSET_TEASER_FIVE_ALIGNMENT_HEADLINE = "right" as const;
export const OFFSET_TEASER_FIVE_ALIGNMENT_HEADLINE_MOBILE = "left" as const;
// pageHeader
export const PAGE_HEADER_HEADLINE_ALIGNMENT = "left" as const;
export const PAGE_HEADER_CONTENT_ALIGNMENT = "left" as const;
export const PAGE_HEADER_SUBHEADLINE_SIZE = "h5" as const;
// pageHeaderCircle
// radioButton
export const RADIO_BUTTON_GROUP_LABEL_FORMAT = ["h3", "h4", "h5", "abstract", "copy", "copy-small"] as const;
// section
export const SECTION_SHOW_FOOTER_SEPARATOR = true as const;
// sitelink
export const SITELINK_LINK_FONT_SIZE = "24px" as const;
// stage
export const STAGE_DEFAULT_ALIGNMENT = "left" as const;
export const STAGE_DEFAULT_CONTENT_WIDTH = "auto" as const;
export const STAGE_FORCE_CONTENT_ALIGNMENT = "left" as const;
export const STAGE_MOBILE_BOTTOM_VIEW = "true" as const;
// step
export const STEP_PICTOGRAM_SIZE = "extra-small" as const;
// textTeaser
export const TEXT_TEASER_HEADLINE_SIZES = ["h1", "h2", "h3"] as const;
export const TEXT_TEASER_HEADLINE_SIZE = "h3" as const;
export const TEXT_TEASER_DEFAULT_HEADLINE_ALIGNMENT = "left" as const;
export const TEXT_TEASER_CONTENT_ALIGNMENT = "left" as const;
export const TEXT_TEASER_PICTOGRAM_ALIGNMENT = "left" as const;
export const TEXT_TEASER_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_PICTOGRAM_WITH_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_DEFAULT_HEADLINE_WITH_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_CONTENT_WITH_NUMBER_ALIGNMENT = "left" as const;
// tilesTeaser
export const TILES_TEASER_COLORS = ["bright"] as const;
// tooltip
export const TOOLTIP_CONTENT_ALIGNMENT = ["left", "center"] as const;
export const TOOLTIP_DEFAULT_CONTENT_ALIGNMENT = "left" as const;
// videoplayer
export const VIDEOPLAYER_BUTTON_SCHEME = "Quartzgrau75" as const;
// videoplayer
export const VIDEOPLAYER_FILLED_ICON = false as const;
